import React from 'react'
import styles from './style.module.css'
import InputMask from 'react-input-mask'

const Input = ({
  name,
  placeholder,
  value,
  onChange,
}) => {

  return (
    <InputMask 
      className={styles.input}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      mask=""
      maskChar=""
    />
  )
}

export default Input 
